<template lang="pug">
.usage-fees-tokuyo-food-costs-table
  .d-flex.flex-row.align-items-center.mb-2
    .title.mr-1 食費（日額） ※ 募集ページでは30日分を月額として概算
    span.validation-label 必須
  b-table-simple.dark-boder-table.waiter-judge-template-table
    b-thead
      b-tr
        b-th 第1段階
        b-th 第2段階
        b-th 第3段階①
        b-th 第3段階②
        b-th 第4段階
    b-tbody
      b-tr
        b-td
          .d-flex.flex-row.align-items-center
            b-form-input.mr-1(v-model.number="_value.paymentCeiling_1"
              :name="'usage-fees-tokuyo-food-costs-payment-ceiling-1'"
              :maxlength="10" :class="[ { noinput: _value.paymentCeiling_1 == null } ]"
              v-validate="{ required: true, max: 10 }" :data-vv-as="'食費の第1段階'")
            span 円
        b-td
          .d-flex.flex-row.align-items-center
            b-form-input.mr-1(v-model.number="_value.paymentCeiling_2"
              :name="'usage-fees-tokuyo-food-costs-payment-ceiling-2'"
              :maxlength="10" :class="[ { noinput: _value.paymentCeiling_2 == null } ]"
              v-validate="{ required: true, max: 10 }" :data-vv-as="'食費の第2段階'")
            span 円
        b-td
          .d-flex.flex-row.align-items-center
            b-form-input.mr-1(v-model.number="_value.paymentCeiling_3_1"
              :name="'usage-fees-tokuyo-food-costs-payment-ceiling-3-1'"
              :maxlength="10" :class="[ { noinput: _value.paymentCeiling_3_1 == null } ]"
              v-validate="{ required: true, max: 10 }" :data-vv-as="'食費の第3段階①'")
            span 円
        b-td
          .d-flex.flex-row.align-items-center
            b-form-input.mr-1(v-model.number="_value.paymentCeiling_3_2"
              :name="'usage-fees-tokuyo-food-costs-payment-ceiling-3-2'"
              :maxlength="10" :class="[ { noinput: _value.paymentCeiling_3_2 == null } ]"
              v-validate="{ required: true, max: 10 }" :data-vv-as="'食費の第3段階②'")
            span 円
        b-td
          .d-flex.flex-row.align-items-center
            b-form-input.mr-1(v-model.number="_value.paymentCeiling_4"
              :name="'usage-fees-tokuyo-food-costs-payment-ceiling-4'"
              :maxlength="10" :class="[ { noinput: _value.paymentCeiling_4 == null } ]"
              v-validate="{ required: true, max: 10 }" :data-vv-as="'食費の第4段階'")
            span 円

  .errors(v-for="fieldName in _fieldNames")
    .error-messages(v-for="error in errors.collect(fieldName)")
      .error-message {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { PaymentCeiling } from "@/commons/services/WaiterRecruitments";

/**
 * ### 料金シミュレーション(特養タイプ) 部屋料金コンポーネント
 */
@Component({})
export default class UsageFeesTokuyoFoodCostsTable extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  @Prop()
  value!: PaymentCeiling;

  get _value(): PaymentCeiling {
    return this.value;
  }

  set _value(newValue: PaymentCeiling) {
    this.$emit("input", newValue);
    return;
  }

  get _fieldNames(): string[] {
    return [
      `usage-fees-tokuyo-food-costs-payment-ceiling-1`,
      `usage-fees-tokuyo-food-costs-payment-ceiling-2`,
      `usage-fees-tokuyo-food-costs-payment-ceiling-3-1`,
      `usage-fees-tokuyo-food-costs-payment-ceiling-3-2`,
      `usage-fees-tokuyo-food-costs-payment-ceiling-4`
    ];
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.usage-fees-tokuyo-food-costs-table {
  .title {
    font-size: 18px;
    font-weight: bold;
  }
  .validation-label {
    color: $validation-label-font-color;
    font-size: 10px;
    border: 1px solid $validation-label-font-color;
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
  .noinput {
    background-color: $bg-require-input !important;
    &::placeholder {
      color: rgb(117, 117, 117);
    }
  }
}
</style>
